module.exports = __webpack_public_path__ + "img/wechat-code.78661514.png";